import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import { Input } from "@/components/ui/input";
import { BookOpen, Search } from "lucide-react";

export default function Knowledge() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    const t = setTimeout(() => {
      api.get(`/knowledge${q ? `?q=${encodeURIComponent(q)}` : ""}`).then(({ data }) => setItems(data));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="min-h-screen warm-grain">
      <Navbar />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10">
        <div className="text-xs font-mono-label text-[color:hsl(var(--amber))]">Reusable knowledge</div>
        <h1 className="mt-2 font-display font-extrabold text-3xl sm:text-4xl">Solutions preserved by real people.</h1>
        <p className="mt-3 text-muted-foreground max-w-2xl">Every CLING solve can become knowledge for the next person. Search what's already been figured out.</p>

        <div className="mt-6 relative max-w-xl">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search solved cases…" className="pl-9 h-11 rounded-full" data-testid="knowledge-search" />
        </div>

        <div className="mt-8 grid md:grid-cols-2 gap-4">
          {items.length === 0
            ? <div className="text-muted-foreground text-sm" data-testid="knowledge-empty">No matching cases yet.</div>
            : items.map((c) => (
              <Link key={c.case_id} to={`/knowledge/${c.case_id}`} className="border rounded-2xl bg-card p-5 hover:border-[color:hsl(var(--teal))] transition" data-testid={`kc-${c.case_id}`}>
                <div className="text-xs font-mono-label text-[color:hsl(var(--teal))]">{c.category}</div>
                <div className="mt-1 font-display font-bold text-lg">{c.title}</div>
                <p className="mt-2 text-sm text-muted-foreground line-clamp-3">{c.problem}</p>
                <div className="mt-3 inline-flex items-center gap-1 text-xs text-[color:hsl(var(--amber))]"><BookOpen className="w-3 h-3" /> View solution</div>
              </Link>
            ))
          }
        </div>
      </div>
    </div>
  );
}
